import { ITreeViewTurma } from "@deltasge/marauders-map";

import { createActionWithPayload } from "store/helpers";
import { ActionTypes } from "./types";

export const set = createActionWithPayload<ITreeViewTurma>(ActionTypes.SET);
